import React, { useContext } from 'react';
import VideoGadget, { VideoGadgetPrintPlaceholder } from './VideoGadget';
import Loading from '../Loading';
import usePopup from '../../hooks/usePopup';
import { WallboardPrintContext } from '../../contextProviders/WallboardPrintProvider';
import useVideoSrc from './useVideoSrc';

const VideoGadgetContainer = ({ storagePath }: { storagePath: string }) => {
  const {
    isOpen: isEditFormOpen,
    open: openEditForm,
    close: closeEditForm,
  } = usePopup();
  const { isWallboardPrint } = useContext(WallboardPrintContext);
  // Capturing a wallboard screenshot: the TV plays the video itself, so don't
  // load it here.
  const {
    videoSrc: downloadUrl,
    setVideoSrc: setDownloadUrl,
    isLoading,
  } = useVideoSrc(isWallboardPrint ? undefined : storagePath);

  if (isWallboardPrint) {
    return <VideoGadgetPrintPlaceholder storagePath={storagePath} />;
  }

  if (downloadUrl && !isLoading) {
    return (
      <VideoGadget
        src={downloadUrl}
        setSrc={setDownloadUrl}
        storagePath={storagePath}
        isEditFormOpen={isEditFormOpen}
        openEditForm={openEditForm}
        closeEditForm={closeEditForm}
      />
    );
  } else {
    return <Loading />;
  }
};

export default VideoGadgetContainer;
